import CancelIcon from "@mui/icons-material/Cancel";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import { Chip } from "@mui/material";
import type { ReactElement } from "react";

import type { ResultValue } from "../data/types";

interface OddsChipProps {
  correct: boolean;
  mine: boolean;
  odds?: number;
  sign: ResultValue;
  margin?: number;
}

export function OddsChip({
  margin = 5,
  sign,
  correct,
  odds,
  mine,
}: OddsChipProps): JSX.Element {
  return (
    <Chip
      label={odds ? odds : "TBA"}
      icon={renderIcon(sign)}
      color={correct ? "secondary" : mine ? "primary" : undefined}
      data-sign={sign}
      style={{
        margin,
        ...(correct && mine ? { backgroundColor: "#357a38" } : undefined),
      }}
    />
  );
}

function renderIcon(sign: ResultValue): ReactElement | undefined {
  switch (sign) {
    case "1":
      return <LooksOneIcon data-testid="odds-icon-1" />;
    case "X":
      return <CancelIcon data-testid="odds-icon-X" />;
    case "2":
      return <LooksTwoIcon data-testid="odds-icon-2" />;
    default:
      return undefined;
  }
}
